module.exports = __webpack_public_path__ + "img/ssa-1.dbd05334.svg";